import React, { Component } from "react";
export default class LanguageSpellingSection extends Component {
  render() {
    var {
      spelling_portrait_text_status,
      spelling_portrait_text,
      spelling_babysitter_text_status,
      spelling_babysitter_text,
      spelling_entertaining_text_status,
      spelling_entertaining_text,
      spelling_reduction_text_status,
      spelling_reduction_text,
      spelling_aquarium_text_status,
      spelling_aquarium_text,
      spelling_lifeguard_text_status,
      spelling_lifeguard_text,
      spelling_borrow_text_status,
      spelling_borrow_text,
      spelling_suggested_text_status,
      spelling_suggested_text,
      spelling_headlight_text_status,
      spelling_headlight_text,
      spelling_schedule_text_status,
      spelling_schedule_text,
      spelling_wheelbarrow_text_status,
      spelling_wheelbarrow_text,
      spelling_score,
      spelling_wrote_text_status,
      spelling_wrote_text,
    } = this.props.data;
    return (
      <div className="row border border-dark bg-white">
        <div className="col-lg-12">
          <table className="w-100">
            <tbody>
              <tr>
                <td>
                  <br />
                  <div className="row p-3">
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">1. Portrait </p>
                      <input
                        value={spelling_portrait_text}
                        name="spelling_portrait_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">2. Babysitter </p>
                      <input
                        value={spelling_babysitter_text}
                        name="spelling_babysitter_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">3. Entertaining </p>
                      <input
                        value={spelling_entertaining_text}
                        name="spelling_entertaining_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">4. Reduction </p>
                      <input
                        value={spelling_reduction_text}
                        name="spelling_reduction_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">5. Aquarium </p>
                      <input
                        value={spelling_aquarium_text}
                        name="spelling_aquarium_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">6. Lifeguard </p>
                      <input
                        value={spelling_lifeguard_text}
                        name="spelling_lifeguard_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">7. Borrow </p>
                      <input
                        value={spelling_borrow_text}
                        name="spelling_borrow_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">8. Suggested </p>
                      <input
                        value={spelling_suggested_text}
                        name="spelling_suggested_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">9. Headlight </p>
                      <input
                        value={spelling_headlight_text}
                        name="spelling_headlight_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">10. Schedule </p>
                      <input
                        value={spelling_schedule_text}
                        name="spelling_schedule_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">11. Wheelbarrow </p>
                      <input
                        value={spelling_wheelbarrow_text}
                        name="spelling_wheelbarrow_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                    <div className="col-lg-6">
                      <p className="fs-19 mb-3">12. Wrote </p>
                      <input
                        value={spelling_wrote_text}
                        name="spelling_wrote_text"
                        type="text"
                        className="ecas-input-field"
                      />
                    </div>
                  </div>
                  <hr />
                  <div className="col-lg-6">
                    <span className="fs-19">Score (0-12) </span>
                    <input
                      type="number"
                      disabled
                      name="spelling_score"
                      value={spelling_score}
                      className="ecas-input-field"
                      placeholder="Score"
                    />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
